module.exports = __webpack_public_path__ + "img/business-and-finance.8d2704e6.svg";